import React, { useState, useRef, useEffect } from 'react';
import Webcam from 'react-webcam';
import { v4 as uuidv4 } from 'uuid';
import { InferenceEngine, CVImage } from 'inferencejs';
import './App.css';

function App() {
  const webcamRef = useRef(null);
  const inferEngine = useRef(null);
  const workerId = useRef(null);

  const viewsConfig = [
    {
      images: [
        "/assets/View_1_Open_Unselect.png",
        "/assets/View_1_Open_Select.png",
        "/assets/View 1_Confirmed.png",
        "/assets/View1_Reshoot.png"
      ],
      outline: "/assets/Outline_1.png",
      setIndex: useState(0),
      setBlob: useState(null),
      setShowTick: useState(false),
      setLoading: useState(false)
    }
    // {
    //   images: [
    //     "/assets/View_2_Open_Unselect.png",
    //     "/assets/View_2_Capture.png",
    //     "/assets/View 2_Confirmed.png",
    //     "/assets/View2_Reshoot.png"
    //   ],
    //   outline: "/assets/Outline_2.png",
    //   setIndex: useState(0),
    //   setBlob: useState(null),
    //   setShowTick: useState(false),
    //   setLoading: useState(false)
    // }
  ];

  const [screenShotImage] = useState("/assets/Sreenshot1.png");
  const [progressPercentage] = useState(77);
  const [activeView, setActiveView] = useState(null);
  const [lastSelectedView, setLastSelectedView] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isPreviewMode, setIsPreviewMode] = useState(false);
  const [currentPreviewIndex, setCurrentPreviewIndex] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isValidating, setIsValidating] = useState(false);
  const [isvalidatingDone, setISValidationDone] = useState(false);
  const [footerHidden, setFooterHidden] = useState(false);
  const [predictionConfidence, setPredictionConfidence] = useState(null);
  const [isDetecting, setIsDetecting] = useState(false);
  const [showFullPreview, setShowFullPreview] = useState(null);
  const [predictionDiff, setPredictionDiff] = useState({});

  // Use a local state to trigger re-render when prediction changes

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);

      // Dynamically set the viewport height CSS variable
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    handleResize(); // Run once on mount
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);


  const captureImageBlob = async (videoEl) => {
    const canvas = document.createElement('canvas');
    canvas.width = videoEl.videoWidth;
    canvas.height = videoEl.videoHeight;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(videoEl, 0, 0, canvas.width, canvas.height);
    return new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg'));
  };

  // Model config
  const modelProject = 'laptop-position';
  const modelVersion = '1';
  const apiKey = 'rf_hgPzt2kmLnmljsRM33XO';

  useEffect(() => {
    // Initialize inference engine and load model
    const setupInference = async () => {
      inferEngine.current = new InferenceEngine();
      workerId.current = await inferEngine.current.startWorker(
        modelProject,
        modelVersion,
        apiKey
      );
    };
    setupInference();
    return () => {
      if (workerId.current && inferEngine.current) {
        inferEngine.current.stopWorker(workerId.current);
      }
    };
  }, []);

  // Flicker fix: debounce UI feedback with frame counters
  const validFrameThreshold = 5; // Number of consecutive valid frames required
  const invalidFrameThreshold = 3; // Number of consecutive invalid frames required
  const validFrameCount = useRef(0);
  const invalidFrameCount = useRef(0);

  // Updated detectFrame to update both lastPredictionRef and predictionDiff
  const detectFrame = async () => {
    if (!workerId.current || !webcamRef.current || !webcamRef.current.video) {
      requestAnimationFrame(detectFrame);
      return;
    }
    const image = new CVImage(webcamRef.current.video);
    try {
      const predictions = await inferEngine.current.infer(workerId.current, image);
      console.log("Predictions:", predictions);
      let status = 'incorrect';
      if (predictions && predictions.length > 0) {
        const topPrediction = predictions[0];
        if (topPrediction.class === 'Correct') {
          status = 'correct';
        }
      } else {
        // If predictions is empty, always set to incorrect
        status = 'incorrect';
      }
      if (status === 'correct') {
        validFrameCount.current++;
        invalidFrameCount.current = 0;
        if (validFrameCount.current >= validFrameThreshold) {
          setPredictionDiff({ status });
        }
      } else {
        invalidFrameCount.current++;
        validFrameCount.current = 0;
        if (invalidFrameCount.current >= invalidFrameThreshold) {
          setPredictionDiff({ status: 'incorrect' });
        }
      }
      return status === 'correct';
    } catch (error) {
      invalidFrameCount.current++;
      validFrameCount.current = 0;
      if (invalidFrameCount.current >= invalidFrameThreshold) {
        setPredictionDiff({ status: 'incorrect' });
      }
    }
    requestAnimationFrame(detectFrame);
    return false;
  };

  const handleNext = () => {
    const capturedCount = viewsConfig.filter(view => view.setBlob[0]).length;
    setCurrentPreviewIndex((prev) => (prev + 1) % capturedCount);
  };

  const handlePrev = () => {
    const capturedCount = viewsConfig.filter(view => view.setBlob[0]).length;
    setCurrentPreviewIndex((prev) => (prev === 0 ? capturedCount - 1 : prev - 1));
  };

  const handlePreviewClick = () => {
    const captured = viewsConfig.map(view => view.setBlob[0]).filter(Boolean);
    if (captured.length === 0) return alert("No captured images to preview!");
    setCurrentPreviewIndex(0);
    setIsPreviewMode(true);
  };

  const errorReshootBut = () => {
    setIsValidating(false);
    setISValidationDone(false);
    // setPopupState({ visible: false, status: 'validating' });
  };

  const handleViewClick = async (viewIndex) => {
    const [index, setIndex] = viewsConfig[viewIndex].setIndex;
    const [, setBlob] = viewsConfig[viewIndex].setBlob;
    const [, setShowTick] = viewsConfig[viewIndex].setShowTick;
    const [, setLoading] = viewsConfig[viewIndex].setLoading;

    if (activeView !== null && activeView !== viewIndex) return;
    setActiveView(viewIndex);
    setLastSelectedView(viewIndex);
    setFooterHidden(true); // Hide footer when view is clicked

    if (index === 0) {
      setIndex(1);
      setIsDetecting(true); // Start detection
    } else if (index === 1 || index === 3) { /* || index === 3 */
      setLoading(true);
      setShowTick(true);
      setIsValidating(true)
      setIsDetecting(true); // Ensure detection is running

      const blob = await captureImageBlob(webcamRef.current.video);

      const isValid = await detectFrame();


      if (isValid) {
        setIsValidating(false)
        // setPopupState({ visible: false, status: 'validating' });
        setBlob(blob);
        setIndex(2);
        setTimeout(() => {
          setLoading(false);
          setShowTick(false);
          setActiveView(null);
          setIsDetecting(false); // Stop detection after capture
        }, 2000);
      } else {
        console.log("Invalid Image ####");
        setBlob(null);
        setShowTick(false);
        setISValidationDone(true);
      }



    }
    else if (index === 2) {
      setIndex(3);
    }
  };

  const handleUploadClick = async () => {
    let hasBlob = viewsConfig.some(view => view.setBlob[0]);
    if (!hasBlob) return alert("No images to upload!");

    setIsUploading(true);
    setUploadProgress(0);

    const uploadSingle = async (blob, label, index) => {
      const filename = `${label}_${uuidv4()}.png`;
      const formData = new FormData();
      formData.append('file', blob, filename);
      const res = await fetch('https://testapi4.kaalo.com/upload', {
        method: 'POST',
        body: formData
      });
      if (!res.ok) throw new Error(`${label} upload failed`);
      setUploadProgress(Math.round(((index + 1) / viewsConfig.filter(v => v.setBlob[0]).length) * 100));
      return res.json();
    };

    try {
      const blobsToUpload = viewsConfig.map((view, i) => [view.setBlob[0], i]).filter(([blob]) => blob);
      for (const [blob, i] of blobsToUpload) {
        await uploadSingle(blob, `view${i + 1}`, i);
        viewsConfig[i].setBlob[1](null);
        viewsConfig[i].setIndex[1](0);
      }
      alert("✅ Images uploaded successfully!");
    } catch (err) {
      alert("Upload failed! " + err.message);
    } finally {
      setIsUploading(false);
    }
  };

  const getInstructionText = () => {
    const allReady = viewsConfig.every(view => view.setIndex[0] === 2);
    if (allReady) return <p>Ready for upload.</p>;

    let viewToUse = activeView ?? lastSelectedView ?? viewsConfig.findIndex(view => view.setIndex[0] === 0);
    if (viewToUse === -1 || viewToUse === undefined) return null;

    const [index] = viewsConfig[viewToUse].setIndex;

    if (index === 0) {
      return (
        <>
          <p>Tap ‘View’ to align the position.</p>
          <p>Tap ‘Preview’ to review images.</p>
          <p>Tap ‘Upload’ when ready.</p>
        </>
      );
    } else if (index === 1) {
      return <p>Tap ‘Capture’ to store the image once aligned.</p>;
    } else if (index === 3) {
      return <p>Tap ‘Reshoot’ to capture the image again.</p>;
    } else if (index === 2) {
      return (
        <>
          <p>Tap ‘View’ to align the position.</p>
          <p>Tap ‘Preview’ to review images.</p>
          <p>Tap ‘Upload’ when ready.</p>
        </>
      );
    }

    return null;
  };

  const handleFooterUp = () => {
    setFooterHidden(false); // Show footer when up arrow is clicked
  };

  //continuous loop using requestAnimationFrame
  useEffect(() => {
    let isActive = true;
    async function detectLoop() {
      if (isDetecting && webcamRef.current && webcamRef.current.video && isActive) {
        await detectFrame();
        requestAnimationFrame(detectLoop);
      }
    }
    if (isDetecting) {
      requestAnimationFrame(detectLoop);
    }
    return () => {
      isActive = false;
    };
  }, [isDetecting]);

  const handleCapture = async () => {
    if (webcamRef.current && webcamRef.current.video) {
      const video = webcamRef.current.video;
      const blob = await captureImageBlob(video);
      // Save the blob to the active view
      if (activeView !== null) {
        viewsConfig[activeView].setBlob[1](blob);
        viewsConfig[activeView].setIndex[1](2);
        setFooterHidden(false);
        setIsDetecting(false); // Stop detection only after capture
        setPredictionDiff({ status: 'incorrect' }); // Reset status after capture
        // setPopupState({ visible: true, status: 'empty' });
        setShowFullPreview(blob); // Show full preview
        setTimeout(() => setShowFullPreview(null), 5000); // Hide after 5 seconds
      }
    }
  };

  const videoConstraints = {
  facingMode: 'environment'
};

  return (
    <div className="app-container">
      {/* Full viewport preview after capture, with more transparent overlay */}
      {showFullPreview && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.4)', zIndex: 99999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <img
            src="/assets/DARA.png"
            alt="DARA"
            className="top-left DARA"
            style={{ position: 'absolute', top: 24, left: 24, width: 80, zIndex: 100000 }}
          />
          <div >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginBottom: 20 }}>
              <img src="/assets/whiteTick.png" alt="tick" style={{ width: 56, height: 56, marginBottom: 12 }} />
              <div style={{ color: '#fff', fontWeight: 500, fontSize: 15, textShadow: '0 2px 8px #000' }}>Captured image is stored!</div>
            </div>
            <img
              src={URL.createObjectURL(showFullPreview)}
              alt="Captured Preview"
              className={isMobile ? 'captured-preview-mobile' : ''}
              style={!isMobile ? { width: 350, height: 450, borderRadius: 12, boxShadow: '0 0 24px #000', objectFit: 'contain' } : {}}
            />
          </div>
        </div>
      )}

      {isPreviewMode && (
        <div className="preview-overlay">
          <button className="close-preview-btn" onClick={() => setIsPreviewMode(false)}>✕</button>
          <div className="previewImg">
            <img src="assets/Preview_images.png" className="whiteTick" alt="Preview Label" />
            <div className="imgAddTxt">Preview images</div>
            {(() => {
              const previewBlobs = viewsConfig.map(view => view.setBlob[0]).filter(Boolean);
              const previewURL = previewBlobs[currentPreviewIndex]
                ? URL.createObjectURL(previewBlobs[currentPreviewIndex])
                : screenShotImage;
              return (
                <>
                  {/* <img src="/assets/Mask_Group_2.png" alt="mask_group" className="top-right mask_group" /> */}
                  <img src={previewURL} className="screenShotImage" alt={`Preview ${currentPreviewIndex + 1}`} />
                  <img src="assets/Left_arrow.png" className="leftArrow" alt="Left" onClick={handlePrev} />
                  <img src="assets/Right_arrow.png" className="rightArrow" alt="Right" onClick={handleNext} />
                  <div className="pageNo">
                    {currentPreviewIndex + 1} of {previewBlobs.length}
                  </div>
                </>
              );
            })()}
          </div>
        </div>
      )}

      {isUploading && (
        <div className="uploading-overlay">
          <div className="circular-progress">
            <svg width="120" height="120">
              <circle className="bg" cx="60" cy="60" r="54" />
              <circle
                className="progress"
                cx="60"
                cy="60"
                r="54"
                style={{ strokeDashoffset: `calc(339.292 - (339.292 * ${uploadProgress} / 100))` }}
              />
            </svg>
            <div className="label">
              <div className="status">Uploading...</div>
              <div className="count">{uploadProgress}%</div>
            </div>
          </div>
        </div>
      )}

      {isMobile ? (
        <Webcam
          audio={false}
          ref={webcamRef}
          screenshotFormat="image/jpeg"
          screenshotQuality={1}
          className="fullscreen-webcam"
          videoConstraints={{
            facingMode: "environment"
          }}
        />
      ) : (
        <Webcam
          audio={false}
          ref={webcamRef}
          screenshotFormat="image/jpeg"
          screenshotQuality={1}
          className="fullscreen-webcam"
        />
      )}

      {/* Validation Successful UI */}
      {predictionDiff.status === 'correct' && (
        <div className="validation-popup">
          <div className="popup-content">
            <div className="popup-title">Validation Successful.</div>
            <div className="popup-contentdesc">Tap ‘Capture’ to proceed</div>
          </div>
        </div>
      )}

      {!isPreviewMode && !isUploading && !isValidating && !showFullPreview && (
        <>
          <div className="main-content">
            <img
              src="/assets/DARA.png"
              alt="DARA"
              className="top-left DARA"
              style={{ position: 'absolute', top: 24, left: 24, width: 80, zIndex: 100000 }}
            />

            {activeView !== null && !viewsConfig.some(view => view.setShowTick[0]) && (
              <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-end' }}>
                <img
                  src={
                    predictionDiff.status === 'correct'
                      ? '/assets/Validation_complete.png'
                      : '/assets/Front_View_outline.png'
                  }
                  alt="Outline"
                  className="centered-screen-image"
                />
                {/* Prediction value below green border, then Capture button below that */}
              </div>
            )}

            {viewsConfig.map((view, i) => {
              const [showTick] = view.setShowTick;
              const [blob] = view.setBlob;

              if (!showTick || !blob) return null; // 💡 Prevents showing overlay prematurely

              const previewURL = URL.createObjectURL(blob);
              return (
                <div key={i} className="preview-overlay">
                  <div className="imageAdded">
                    <img src="assets/whiteTick.png" className="whiteTick" alt="tick" />
                    <div className="imgAddTxt">Image Added!</div>
                    <img src={previewURL} className="screenShotImage" alt={`Screenshot ${i + 1}`} />
                  </div>
                </div>
              );
            })}
          </div>

          <div
            className={`footer${footerHidden ? ' footer-hidden' : ''}`}
            style={footerHidden ? {} : { backgroundImage: `url('/assets/Blue_box.png')` }}
          >
            <div className="image-overlay">
              {!footerHidden && viewsConfig.map((view, i) => {
                const [index] = view.setIndex;
                const isConfirmed = index === 2;
                return (
                  <img
                    key={i}
                    src={view.images[index]}
                    alt={`View ${i + 1}`}
                    className="overlay-img"
                    onClick={isConfirmed ? undefined : () => handleViewClick(i)}
                    style={{ cursor: isConfirmed ? "not-allowed" : (activeView !== null && activeView !== i ? "not-allowed" : "pointer") }}
                  />
                );
              })}
            </div>

            {/* Remove prediction-info and capture button from footer */}
            {/* {predictionConfidence !== null && (
              <div className="prediction-info">
                {/* moved to below outline }
              </div>
            )} */}

            <div className="upload-container">
              <div className='Preview_button'>
                <img className='Upload_button' src="/assets/Preview_button.png" alt="Preview Button" onClick={handlePreviewClick} />
                <img className='Upload_button' src="/assets/Upload_button.png" alt="Upload Button" onClick={handleUploadClick} />
              </div>
              <div className="viewText">
                {getInstructionText()}
              </div>
            </div>
          </div>
          {/* {footerHidden && (
            <button className="footer-up-arrow" onClick={handleFooterUp}>
              <img src="/assets/Right_arrow.png" alt="Up Arrow" style={{ transform: 'rotate(-90deg)', width: 40, height: 40 }} />
            </button>
          )} */}

          {/* Show up arrow only if footer is hidden and validation is NOT successful */}
          {footerHidden && !(predictionDiff.status === 'correct') && (
            <button className="footer-up-arrow" onClick={handleFooterUp}>
              <img src="/assets/Right_arrow.png" alt="Up Arrow" style={{ transform: 'rotate(-90deg)', width: 40, height: 40 }} />
            </button>
          )}

          {/* Show capture sprite at bottom only if footer is hidden and validation is successful */}
          {footerHidden && (predictionDiff.status === 'correct') && (
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', position: 'fixed', bottom: '10%', left: 0, zIndex: 1001 }}>
              <img
                src="/assets/Capture_Sprite_2.png"
                alt="Capture Sprite"
                className="capture-sprite"
                style={{ cursor: 'pointer', width: 80, height: 80 }}
                onClick={() => { setIsDetecting(false); handleCapture(); }}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default App;
